/** PageHeader — the screen title block (title + subtitle + optional header-end actions). RTL-safe. */
import type { ReactNode } from "react";

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <header
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: "var(--nv-s-3)",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--nv-s-1)" }}>
        <h1 style={{ margin: 0, fontSize: "var(--nv-fs-h1)", color: "var(--nv-ink)" }}>{title}</h1>
        {subtitle && (
          <p style={{ margin: 0, color: "var(--nv-slate)", fontSize: "var(--nv-fs-body)" }}>{subtitle}</p>
        )}
      </div>
      {actions && <div style={{ display: "flex", gap: "var(--nv-s-2)", alignItems: "center" }}>{actions}</div>}
    </header>
  );
}
